export const DigitalOrdersActionTypes = {
  DIGITAL_REQUEST_ORDERS: 'zola/card/card_project/DIGITAL_REQUEST_ORDERS',
  DIGITAL_RECEIVE_ORDERS: 'zola/card/card_project/DIGITAL_RECEIVE_ORDERS',
  DIGITAL_RECEIVE_CANCELED_ORDER: 'zola/card/card_project/DIGITAL_RECEIVE_CANCELED_ORDER',
};

export default DigitalOrdersActionTypes;
